import {SectionItem} from 'common/components/items-menu/types';

export enum SankeyNodeType {
  Anchor = `ANCHOR`,
  Dropoff = `DROPOFF`,
  Pruned = `PRUNED`,
  Event = `NORMAL`,
  Forward = `FORWARD`,
  Reverse = `REVERSE`,
}

export enum SankeyStepType {
  Anchor = `ANCHOR`,
  Forward = `FORWARD`,
  Reverse = `REVERSE`,
}

export enum SankeyAnchorType {
  Normal = `NORMAL`,
  RelativeReverse = `RELATIVE_REVERSE`,
  RelativeForward = `RELATIVE_FORWARD`,
}

export const SankeyNodeTypePriority = {
  [SankeyNodeType.Dropoff]: 0,
  [SankeyNodeType.Pruned]: 1,
  [SankeyNodeType.Event]: 2,
  [SankeyNodeType.Forward]: 2,
  [SankeyNodeType.Reverse]: 2,
  [SankeyNodeType.Anchor]: 3,
};

export enum Alignment {
  LEFT,
  RIGHT,
}

export const AlignmentOptions: {[key in Alignment]: SectionItem} = {
  [Alignment.LEFT]: {
    icon: `left-align`,
    label: `Analyze Events After`,
    value: Alignment.LEFT,
  },
  [Alignment.RIGHT]: {
    icon: `right-align`,
    label: `Analyze Events Before`,
    value: Alignment.RIGHT,
  },
};
